export const styles = {
  itemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    marginBottom: 5,
  },
  wrapper: {
    padding: '2.5rem',
    marginTop: '2rem',
  },
}
